<template>
  <div class="main_container">
    <NavBar/>
    <div class="main_home">
      <section>
        <div class="main_section terms">
          <h3 class="main_section-title">Terms Of Use</h3>
          <div class="questions_content">
            <p class="main_section-sub">Effective Date: October 24, 2025</p>
            <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
              <div class="tab_block">
                <h4 class="tab_block-name">Welcome to ShonCompany.com.</h4>
                <div class="tab_block-description">By accessing or using this website, you agree to the following terms:
                  <ul>
                    <li>
                      Use of Platform: You may browse listings, create bookings, or list properties only for lawful
                      purposes.
                    </li>
                    <li>
                      Accounts: You are responsible for maintaining the confidentiality of your login credentials and
                      for all activity under your account.
                    </li>
                    <li>
                      Bookings: All bookings are subject to availability, host approval, and payment confirmation.
                      Cancellation policies are set by each property and displayed at checkout.
                    </li>
                    <li>
                      Intellectual Property: All content, branding, and materials on this site are owned by Shon Company
                      and may not be copied or reused without permission.
                    </li>
                    <li>
                      Liability: Shon Company provides the platform “as is” and is not liable for damages arising from
                      use of the site, except as required by law.
                    </li>
                    <li>
                      Changes: We may update these Terms at any time. Continued use of the site indicates your
                      acceptance of the revised Terms.
                    </li>
                  </ul>
                </div>
              

              </div>
              <!--              <div class="tab_block">-->
              <!--                <h4 class="tab_block-name">Your Rights & Choices</h4>-->
              <!--                <div class="tab_block-description">Where applicable (e.g., GDPR, CCPA/CPRA), you have the right to:-->
              <!--                  <ul>-->
              <!--                    <li>Access, correct, or delete personal information</li>-->
              <!--                    <li>Withdraw consent at any time</li>-->
              <!--                    <li>Opt out of marketing communications</li>-->
              <!--                    <li>Object to or restrict certain processing activities</li>-->
              <!--                  </ul>-->
              <!--                  To exercise these rights, contact us at privacy@shoncompany.com.-->
              <!--                </div>-->
              <!--                <h4 class="tab_block-name">Data Security & Retention</h4>-->
              <!--                <p class="tab_block-description">We implement industry-standard security measures (e.g., encryption,-->
              <!--                  access controls) to protect your data. Your information is retained as long as necessary to fulfill-->
              <!--                  its original purpose, comply with legal obligations, resolve disputes, and enforce agreements..</p>-->
              <!--                <h4 class="tab_block-name">Children’s Privacy</h4>-->
              <!--                <p class="tab_block-description">Our Site is not intended for individuals under age 16. We do not-->
              <!--                  knowingly collect personal data from minors. If we learn we have collected such information without-->
              <!--                  parental consent, we will take steps to delete it promptly.</p>-->
              <!--                <h4 class="tab_block-name">International Data Transfers</h4>-->
              <!--                <p class="tab_block-description">If you are outside the U.S., your data may be transferred to and-->
              <!--                  processed in the U.S. or other countries with potentially different privacy laws. We take steps to-->
              <!--                  ensure adequate protection.</p>-->
              <!--                <h4 class="tab_block-name">Changes to This Policy</h4>-->
              <!--                <p class="tab_block-description">We may update this policy to reflect legal or operational changes. We-->
              <!--                  will post the revised version and update the “Effective Date” above. We encourage you to review this-->
              <!--                  page periodically.</p>-->
              <!--                <h4 class="tab_block-name">Contact Us</h4>-->
              <!--                <p class="tab_block-description">For questions, access requests, or to make a complaint, email us at: <br> <br>-->
              <!--                  privacy@shoncompany.com-->
              <!--                </p>-->
              <!--              </div>-->
            </div>
          </div>
        </div>

      </section>
    </div>
    <Footer/>

  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";

export default {
  name: "TermsOfUse",
  components: {
    Footer,
    NavBar,
  },
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.main {
  &_section {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 90px 0;
    @media screen and (max-width: 1680px) {
      padding: 60px 0 30px;
    }
    @media screen and (max-width: 1024px) {
      padding: 40px 0 20px;
    }

    &-title {
      color: #000;
      text-align: center;
      font-size: 48px;
      font-style: normal;
      font-weight: 900;
      line-height: normal;
      padding: 80px 0 40px;
      @media screen and (max-width: 1680px) {
        font-size: 32px;
      }
      @media screen and (max-width: 1024px) {
        font-size: 28px;
      }
      @media screen and (max-width: 540px) {
        font-size: 24px;
      }
    }

    &-sub {
      color: #181A2A;
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px; /* 150% */
    }

    &.terms {
      & .questions {
        &_content {
          width: 85%;
          display: flex;
          flex-direction: column;
          align-items: center;
          @media screen and (max-width: 1440px) {
            width: 80%;
          }
          @media screen and (max-width: 540px) {
            width: 95%;
          }

          & .nav {
            &-pills {
            }

            &-item {
            }

            &-link {
              background: transparent;
              color: #1E1E1E;
              text-align: center;
              font-size: 36px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
              border-radius: 0;

              &.active {
                font-weight: 900;
                border-bottom: 4px solid #068BD6;
              }

              @media screen and (max-width: 540px) {
                font-size: 22px;
              }
            }
          }

          & .tab {
            &-pane {
              display: none;

              &.active {
                display: flex;
              }

              @media screen and (max-width: 440px) {
                flex-direction: column;
              }
            }

            &_block {
              padding: 60px 50px 10px;
              max-width: 780px;
              @media screen and (max-width: 1680px) {
                padding: 40px 35px 10px;
              }
              @media screen and (max-width: 1440px) {
                padding: 30px 20px 10px;
                max-width: 560px;
              }
              @media screen and (max-width: 540px) {
                padding: 20px 10px 0;
              }

              &-name {
                color: #000;
                font-size: 24px;
                font-weight: 700;
                line-height: 32px;
                padding-bottom: 18px;
                text-align: center;
                @media screen and (max-width: 1680px) {
                  font-size: 22px;
                }
                @media screen and (max-width: 1440px) {
                  font-size: 20px;
                  padding-bottom: 10px;
                }
                @media screen and (max-width: 540px) {
                  font-size: 17px;
                }
              }

              &-description {
                color: #181A2A;
                font-size: 16px;
                font-weight: 500;
                line-height: 24px;
                padding-bottom: 40px;
                @media screen and (max-width: 1680px) {
                  font-size: 18px;
                }
                @media screen and (max-width: 1440px) {
                  font-size: 16px;
                  padding-bottom: 50px;
                }
                @media screen and (max-width: 540px) {
                  font-size: 15px;
                  padding-bottom: 20px;
                }

                & ul {
                  margin-bottom: 5px;
                  padding: 10px 15px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
